package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class UserProfileQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    fullname: String,
    email: String,
    avatar_url: String,
    bio: String,
    language: String,
    theme_mode: String,
    finance_default_period: String,
    finance_default_currency: String,
    pomodoro_focus_min: Long,
    pomodoro_short_break_min: Long,
    pomodoro_long_break_min: Long,
    notify_habits: Long,
    notify_deadlines: Long,
    notify_pomodoro_end: Long,
    notify_budget_alerts: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(1_779_176_997, arrayOf("user_profile"), driver, "UserProfile.sq",
      "selectAll",
      "SELECT user_profile.id, user_profile.fullname, user_profile.email, user_profile.avatar_url, user_profile.bio, user_profile.language, user_profile.theme_mode, user_profile.finance_default_period, user_profile.finance_default_currency, user_profile.pomodoro_focus_min, user_profile.pomodoro_short_break_min, user_profile.pomodoro_long_break_min, user_profile.notify_habits, user_profile.notify_deadlines, user_profile.notify_pomodoro_end, user_profile.notify_budget_alerts, user_profile.created_at, user_profile.updated_at, user_profile.is_deleted, user_profile.deleted_at, user_profile.synced_at FROM user_profile WHERE is_deleted = 0 LIMIT 1") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6)!!,
      cursor.getString(7)!!,
      cursor.getString(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15)!!,
      cursor.getLong(16)!!,
      cursor.getLong(17)!!,
      cursor.getLong(18)!!,
      cursor.getLong(19),
      cursor.getLong(20)
    )
  }

  public fun selectAll(): Query<User_profile> = selectAll { id, fullname, email, avatar_url, bio,
      language, theme_mode, finance_default_period, finance_default_currency, pomodoro_focus_min,
      pomodoro_short_break_min, pomodoro_long_break_min, notify_habits, notify_deadlines,
      notify_pomodoro_end, notify_budget_alerts, created_at, updated_at, is_deleted, deleted_at,
      synced_at ->
    User_profile(
      id,
      fullname,
      email,
      avatar_url,
      bio,
      language,
      theme_mode,
      finance_default_period,
      finance_default_currency,
      pomodoro_focus_min,
      pomodoro_short_break_min,
      pomodoro_long_break_min,
      notify_habits,
      notify_deadlines,
      notify_pomodoro_end,
      notify_budget_alerts,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    fullname: String,
    email: String,
    avatar_url: String,
    bio: String,
    language: String,
    theme_mode: String,
    finance_default_period: String,
    finance_default_currency: String,
    pomodoro_focus_min: Long,
    pomodoro_short_break_min: Long,
    pomodoro_long_break_min: Long,
    notify_habits: Long,
    notify_deadlines: Long,
    notify_pomodoro_end: Long,
    notify_budget_alerts: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6)!!,
      cursor.getString(7)!!,
      cursor.getString(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15)!!,
      cursor.getLong(16)!!,
      cursor.getLong(17)!!,
      cursor.getLong(18)!!,
      cursor.getLong(19),
      cursor.getLong(20)
    )
  }

  public fun selectById(id: String): Query<User_profile> = selectById(id) { id_, fullname, email,
      avatar_url, bio, language, theme_mode, finance_default_period, finance_default_currency,
      pomodoro_focus_min, pomodoro_short_break_min, pomodoro_long_break_min, notify_habits,
      notify_deadlines, notify_pomodoro_end, notify_budget_alerts, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    User_profile(
      id_,
      fullname,
      email,
      avatar_url,
      bio,
      language,
      theme_mode,
      finance_default_period,
      finance_default_currency,
      pomodoro_focus_min,
      pomodoro_short_break_min,
      pomodoro_long_break_min,
      notify_habits,
      notify_deadlines,
      notify_pomodoro_end,
      notify_budget_alerts,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    fullname: String,
    email: String,
    avatar_url: String,
    bio: String,
    language: String,
    theme_mode: String,
    finance_default_period: String,
    finance_default_currency: String,
    pomodoro_focus_min: Long,
    pomodoro_short_break_min: Long,
    pomodoro_long_break_min: Long,
    notify_habits: Long,
    notify_deadlines: Long,
    notify_pomodoro_end: Long,
    notify_budget_alerts: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(394_800_982, arrayOf("user_profile"), driver, "UserProfile.sq",
      "selectDirty",
      "SELECT user_profile.id, user_profile.fullname, user_profile.email, user_profile.avatar_url, user_profile.bio, user_profile.language, user_profile.theme_mode, user_profile.finance_default_period, user_profile.finance_default_currency, user_profile.pomodoro_focus_min, user_profile.pomodoro_short_break_min, user_profile.pomodoro_long_break_min, user_profile.notify_habits, user_profile.notify_deadlines, user_profile.notify_pomodoro_end, user_profile.notify_budget_alerts, user_profile.created_at, user_profile.updated_at, user_profile.is_deleted, user_profile.deleted_at, user_profile.synced_at FROM user_profile WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6)!!,
      cursor.getString(7)!!,
      cursor.getString(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15)!!,
      cursor.getLong(16)!!,
      cursor.getLong(17)!!,
      cursor.getLong(18)!!,
      cursor.getLong(19),
      cursor.getLong(20)
    )
  }

  public fun selectDirty(): Query<User_profile> = selectDirty { id, fullname, email, avatar_url,
      bio, language, theme_mode, finance_default_period, finance_default_currency,
      pomodoro_focus_min, pomodoro_short_break_min, pomodoro_long_break_min, notify_habits,
      notify_deadlines, notify_pomodoro_end, notify_budget_alerts, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    User_profile(
      id,
      fullname,
      email,
      avatar_url,
      bio,
      language,
      theme_mode,
      finance_default_period,
      finance_default_currency,
      pomodoro_focus_min,
      pomodoro_short_break_min,
      pomodoro_long_break_min,
      notify_habits,
      notify_deadlines,
      notify_pomodoro_end,
      notify_budget_alerts,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    fullname: String,
    email: String,
    avatar_url: String,
    bio: String,
    language: String,
    theme_mode: String,
    finance_default_period: String,
    finance_default_currency: String,
    pomodoro_focus_min: Long,
    pomodoro_short_break_min: Long,
    pomodoro_long_break_min: Long,
    notify_habits: Long,
    notify_deadlines: Long,
    notify_pomodoro_end: Long,
    notify_budget_alerts: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6)!!,
      cursor.getString(7)!!,
      cursor.getString(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15)!!,
      cursor.getLong(16)!!,
      cursor.getLong(17)!!,
      cursor.getLong(18)!!,
      cursor.getLong(19),
      cursor.getLong(20)
    )
  }

  public fun selectByIdAnyState(id: String): Query<User_profile> = selectByIdAnyState(id) { id_,
      fullname, email, avatar_url, bio, language, theme_mode, finance_default_period,
      finance_default_currency, pomodoro_focus_min, pomodoro_short_break_min,
      pomodoro_long_break_min, notify_habits, notify_deadlines, notify_pomodoro_end,
      notify_budget_alerts, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    User_profile(
      id_,
      fullname,
      email,
      avatar_url,
      bio,
      language,
      theme_mode,
      finance_default_period,
      finance_default_currency,
      pomodoro_focus_min,
      pomodoro_short_break_min,
      pomodoro_long_break_min,
      notify_habits,
      notify_deadlines,
      notify_pomodoro_end,
      notify_budget_alerts,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun upsert(
    id: String,
    fullname: String,
    email: String,
    avatar_url: String,
    bio: String,
    language: String,
    theme_mode: String,
    finance_default_period: String,
    finance_default_currency: String,
    pomodoro_focus_min: Long,
    pomodoro_short_break_min: Long,
    pomodoro_long_break_min: Long,
    notify_habits: Long,
    notify_deadlines: Long,
    notify_pomodoro_end: Long,
    notify_budget_alerts: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(586_265_103, """
        |INSERT OR REPLACE INTO user_profile(
        |    id, fullname, email, avatar_url, bio, language, theme_mode,
        |    finance_default_period, finance_default_currency,
        |    pomodoro_focus_min, pomodoro_short_break_min, pomodoro_long_break_min,
        |    notify_habits, notify_deadlines, notify_pomodoro_end, notify_budget_alerts,
        |    created_at, updated_at
        |) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 18) {
          bindString(0, id)
          bindString(1, fullname)
          bindString(2, email)
          bindString(3, avatar_url)
          bindString(4, bio)
          bindString(5, language)
          bindString(6, theme_mode)
          bindString(7, finance_default_period)
          bindString(8, finance_default_currency)
          bindLong(9, pomodoro_focus_min)
          bindLong(10, pomodoro_short_break_min)
          bindLong(11, pomodoro_long_break_min)
          bindLong(12, notify_habits)
          bindLong(13, notify_deadlines)
          bindLong(14, notify_pomodoro_end)
          bindLong(15, notify_budget_alerts)
          bindLong(16, created_at)
          bindLong(17, updated_at)
        }
    notifyQueries(586_265_103) { emit ->
      emit("user_profile")
    }
  }

  public fun insert(
    id: String,
    fullname: String,
    email: String,
    avatar_url: String,
    bio: String,
    language: String,
    theme_mode: String,
    finance_default_period: String,
    finance_default_currency: String,
    pomodoro_focus_min: Long,
    pomodoro_short_break_min: Long,
    pomodoro_long_break_min: Long,
    notify_habits: Long,
    notify_deadlines: Long,
    notify_pomodoro_end: Long,
    notify_budget_alerts: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(240_868_249, """
        |INSERT INTO user_profile(
        |    id, fullname, email, avatar_url, bio, language, theme_mode,
        |    finance_default_period, finance_default_currency,
        |    pomodoro_focus_min, pomodoro_short_break_min, pomodoro_long_break_min,
        |    notify_habits, notify_deadlines, notify_pomodoro_end, notify_budget_alerts,
        |    created_at, updated_at
        |) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 18) {
          bindString(0, id)
          bindString(1, fullname)
          bindString(2, email)
          bindString(3, avatar_url)
          bindString(4, bio)
          bindString(5, language)
          bindString(6, theme_mode)
          bindString(7, finance_default_period)
          bindString(8, finance_default_currency)
          bindLong(9, pomodoro_focus_min)
          bindLong(10, pomodoro_short_break_min)
          bindLong(11, pomodoro_long_break_min)
          bindLong(12, notify_habits)
          bindLong(13, notify_deadlines)
          bindLong(14, notify_pomodoro_end)
          bindLong(15, notify_budget_alerts)
          bindLong(16, created_at)
          bindLong(17, updated_at)
        }
    notifyQueries(240_868_249) { emit ->
      emit("user_profile")
    }
  }

  public fun update(
    fullname: String,
    email: String,
    avatar_url: String,
    bio: String,
    language: String,
    theme_mode: String,
    finance_default_period: String,
    finance_default_currency: String,
    pomodoro_focus_min: Long,
    pomodoro_short_break_min: Long,
    pomodoro_long_break_min: Long,
    notify_habits: Long,
    notify_deadlines: Long,
    notify_pomodoro_end: Long,
    notify_budget_alerts: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(585_814_441, """
        |UPDATE user_profile SET
        |    fullname = ?, email = ?, avatar_url = ?, bio = ?, language = ?, theme_mode = ?,
        |    finance_default_period = ?, finance_default_currency = ?,
        |    pomodoro_focus_min = ?, pomodoro_short_break_min = ?, pomodoro_long_break_min = ?,
        |    notify_habits = ?, notify_deadlines = ?, notify_pomodoro_end = ?, notify_budget_alerts = ?,
        |    updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 17) {
          bindString(0, fullname)
          bindString(1, email)
          bindString(2, avatar_url)
          bindString(3, bio)
          bindString(4, language)
          bindString(5, theme_mode)
          bindString(6, finance_default_period)
          bindString(7, finance_default_currency)
          bindLong(8, pomodoro_focus_min)
          bindLong(9, pomodoro_short_break_min)
          bindLong(10, pomodoro_long_break_min)
          bindLong(11, notify_habits)
          bindLong(12, notify_deadlines)
          bindLong(13, notify_pomodoro_end)
          bindLong(14, notify_budget_alerts)
          bindLong(15, updated_at)
          bindString(16, id)
        }
    notifyQueries(585_814_441) { emit ->
      emit("user_profile")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(1_583_741_575,
        """UPDATE user_profile SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(1_583_741_575) { emit ->
      emit("user_profile")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(380_847_957,
        """UPDATE user_profile SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(380_847_957) { emit ->
      emit("user_profile")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(-1_982_638_674,
        """UPDATE user_profile SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(-1_982_638_674) { emit ->
      emit("user_profile")
    }
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("user_profile", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("user_profile", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-680_046_642,
        """SELECT user_profile.id, user_profile.fullname, user_profile.email, user_profile.avatar_url, user_profile.bio, user_profile.language, user_profile.theme_mode, user_profile.finance_default_period, user_profile.finance_default_currency, user_profile.pomodoro_focus_min, user_profile.pomodoro_short_break_min, user_profile.pomodoro_long_break_min, user_profile.notify_habits, user_profile.notify_deadlines, user_profile.notify_pomodoro_end, user_profile.notify_budget_alerts, user_profile.created_at, user_profile.updated_at, user_profile.is_deleted, user_profile.deleted_at, user_profile.synced_at FROM user_profile WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "UserProfile.sq:selectById"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("user_profile", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("user_profile", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-869_944_333,
        """SELECT user_profile.id, user_profile.fullname, user_profile.email, user_profile.avatar_url, user_profile.bio, user_profile.language, user_profile.theme_mode, user_profile.finance_default_period, user_profile.finance_default_currency, user_profile.pomodoro_focus_min, user_profile.pomodoro_short_break_min, user_profile.pomodoro_long_break_min, user_profile.notify_habits, user_profile.notify_deadlines, user_profile.notify_pomodoro_end, user_profile.notify_budget_alerts, user_profile.created_at, user_profile.updated_at, user_profile.is_deleted, user_profile.deleted_at, user_profile.synced_at FROM user_profile WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "UserProfile.sq:selectByIdAnyState"
  }
}
